<div class="dashboard">
    <div class="ui-g">
        <div class="ui-lg-6 ui-md-6 ui-sm-12">
            <p-panel styleClass="chart" header="Top 10 Sources by User Count">
                <p-chart type="pie" [data]="userSourceData"></p-chart>
                <div class="text-center">
                    <strong>Total Count: {{ totalCount | number }}</strong>
                </div>
            </p-panel>
        </div>
        <div class="ui-lg-6 ui-md-6 ui-sm-12" *ngIf="this.is_primary_provider">
            <p-panel styleClass="chart" header="Top Packages by Count">
                <p-chart type="bar" [data]="totalPackagesData"></p-chart>
                <div class="text-center">
                    <strong>Total Count: {{ totalPackagesCount | number }}</strong>
                </div>
            </p-panel>
        </div>
    </div>
    <div class="ui-g">
        <div class="ui-lg-6 ui-md-6 ui-sm-12">
            <p-panel styleClass="chart" header="Consultaion Status Count">
                <p-chart type="pie" [data]="consultationStatusData"></p-chart>
                <div class="text-center">
                    <strong>Total Count: {{ totalStatusCount | number }}</strong>
                </div>
            </p-panel>
        </div>
    </div>
</div>